const registerModule = {
    title1: "携帯番号に4桁の認証コードを送信します。",
    title2: "SMSで認証番号を送ります。",
    register: "PAYMUL会員登録",
    nextStep: "次へ",
    areaCodeTitle: "エリアコードを選択してください",
    resendText: "* 後にコードを再送する",
    codePrompt: "4桁の認証コードを入力して下さい。",
    setPassword: "パスワード設定",
    sendCodeText: "上記の番号にSMSで認証コードを送ります。通信状況によっては、多少お時間がかかる場合がございます。",
    isPhone: "携帯番号をご入力ください",
    sendCodeAgain: "* 宛に再送信する",
    sendSuccess: "送信しました",
    passwordHint: "半角英数字6～32文字でご入力ください",
    isPassword: "パスワードをご入力ください",
    samePassword: "ご入力されたパスワードが一致しません",
    registerSuccess: "新規登録しました",
    forgetPwTitle: "パスワード再発行",
    newPassword: "新しいパスワード",
    restSuccess: "設定完了しました",
    sendCode: "認証コードを受信",
    requiredEmail: '送信先メールアドレス',
    phoneError: "正しい携帯番号をご入力ください",
};

export default registerModule;
